import React, { Component } from 'react';
import { Button, Card, Col, Divider, Form, message, Row, Table } from 'antd';
import { Link } from 'react-router';

import moment from 'moment';
import util from '@util/index';
import DescriptionList from '@comm/DescriptionList';
import YearPicker from '@comm/YearPicker';
import { goBack } from '@comm/BackBtn';
import {
  queryBackAllBonus,
  queryBackBonus,
  queryBonusDetailList,
  queryBonusStaticComMonth,
  querySendAllBonus,
  querySendBonus,
} from '@api/hr/bonus';

const FormItem = Form.Item;
const { Description } = DescriptionList;

class PageMonthCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      total: 0,
      pageNo: 1,
      staticData: {},
      sendAllLoading: false,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  getParams = () => {
    const {
      params: { uuid },
    } = this.props;
    return {
      ...this.props.form.getFieldsValue(),
      companyUuid: uuid,
    };
  };

  bonusStaticComMonth = () => {
    queryBonusStaticComMonth(this.getParams()).then(res => {
      this.setState({
        staticData: res.data,
      });
    });
  };

  bonusDetailList = pageNo => {
    const params = {};
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    queryBonusDetailList({
      ...this.getParams(),
      ...params,
    }).then(res => {
      this.setState({
        data: res.data,
        total: res.totalSize,
      });
    });
  };

  loadData = () => {
    this.bonusStaticComMonth();
    this.bonusDetailList();
  };

  handleSearch = e => {
    e.preventDefault();
    this.loadData();
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form layout="inline" style={{ textAlign: 'right' }} onSubmit={this.handleSearch}>
        <FormItem>
          {getFieldDecorator('year', {
            initialValue: moment.unix(new Date().getTime() / 1000).format('YYYY'),
          })(<YearPicker style={{ width: '200px' }} />)}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit" style={{ marginRight: '-16px' }}>
            查询
          </Button>
        </FormItem>
      </Form>
    );
  };

  bonusSend = uuid => {
    querySendBonus({
      uuids: [uuid],
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.bonusDetailList();
      } else {
        message.error(res.message);
      }
    });
  };

  bonusBack = uuid => {
    queryBackBonus({
      uuids: [uuid],
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.bonusDetailList();
      } else {
        message.error(res.message);
      }
    });
  };

  bonusBackAll = () => {
    const params = this.getParams();
    queryBackAllBonus(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.bonusDetailList();
      } else {
        message.error(res.message);
      }
    });
  };

  bonusSendAll = () => {
    const params = this.getParams();
    this.setState({
      sendAllLoading: true,
    });
    querySendAllBonus(params).then(res => {
      this.setState({
        sendAllLoading: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        this.bonusDetailList();
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    return [
      {
        title: '发放年度',
        dataIndex: 'year',
      },
      {
        title: '姓名',
        dataIndex: 'name',
      },
      {
        title: '税前年终奖',
        dataIndex: 'pretax',
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
      {
        title: '个税',
        dataIndex: 'personalTax',
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
      {
        title: '实发年终奖',
        dataIndex: 'netPay',
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
      {
        title: '导入日期',
        dataIndex: 'createTime',
        render: text => <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>,
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return (
            <span>
              <Link to={`/hr/b_manage/detail/${record.uuid}`}>查看</Link>
              <Divider type="verticle" />
              {record.isSendFlag ? null : (
                <a onClick={() => this.bonusSend(record.uuid)}>发送年终奖条</a>
              )}
              {!record.isReadFlag && record.isSendFlag ? (
                <a onClick={() => this.bonusBack(record.uuid)}>收回</a>
              ) : null}
            </span>
          );
        },
      },
    ];
  };

  render() {
    const { data, total, staticData } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: this.state.pageNo,
      onChange: current => {
        this.bonusDetailList(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div>
          <Row>
            <Col span={6}>
              <Button icon="left" shape="circle" style={{ marginRight: 10 }} onClick={goBack} />
            </Col>
            <Col span={18}>{this.renderSearchForm()}</Col>
          </Row>
        </div>
        <Divider />
        <div>
          <DescriptionList size="large" style={{ marginBottom: 32 }} col={3}>
            <Description term="公司名称">{staticData.companyName}</Description>
            <Description term="员工人数">{staticData.hrCount}</Description>
            <Description term="实发年终奖总额">
              {util.numberFormat(staticData.netPay, 2, '.', ',')}元
            </Description>
          </DescriptionList>
        </div>
        <div className="tableList" style={{ textAlign: 'right' }}>
          <Button
            style={{ margin: '0 8px 16px 0' }}
            type="primary"
            onClick={() => this.bonusSendAll()}
            loading={this.state.sendAllLoading}
          >
            发送全部年终奖条
          </Button>
          <Button onClick={() => this.bonusBackAll()}>全部撤回</Button>
        </div>
        <Table rowKey="uuid" columns={this.columns()} dataSource={data} pagination={pagination} />
      </Card>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(PageMonthCompany);



// WEBPACK FOOTER //
// ./src/components/hr/bonus/PageYearCompany.js